<template>

  <v-container>

    <v-overlay :value="loading">

      <v-progress-circular indeterminate size="64"></v-progress-circular>

    </v-overlay>

    <v-snackbar v-model="snackbars.errorSnackbar" color="error">

      Please fix the error(s) on the form.

      <template v-slot:action="{ attrs }">

        <v-btn text v-bind="attrs" @click="snackbars.errorSnackbar = false">

          <v-icon>mdi-close-circle</v-icon>

        </v-btn>

      </template>

    </v-snackbar>

    <v-snackbar v-model="snackbars.genericInfoSnackbar" color="primary">

      {{ snackbars.genericInfoText }}

      <template v-slot:action="{ attrs }">

        <v-btn text v-bind="attrs" @click="snackbars.genericInfoSnackbar = false">

          <v-icon>mdi-close-circle</v-icon>

        </v-btn>

      </template>

    </v-snackbar>

    <v-snackbar v-model="snackbars.genericErrorSnackbar" color="error">

      {{ snackbars.genericErrorText }}

      <template v-slot:action="{ attrs }">

        <v-btn text v-bind="attrs" @click="snackbars.genericErrorSnackbar = false">

          <v-icon>mdi-close-circle</v-icon>

        </v-btn>

      </template>

    </v-snackbar>

    <v-dialog v-model="searchDialog" persistent max-width="1000">

      <v-card>

        <v-card-title class="text-h5 word-break"><strong>Search</strong></v-card-title>

        <v-card-text class="text-body-1">

          <v-layout class="mt-4" wrap>

            <v-row>

              <v-col>

                <v-text-field label="Address" v-model="searchFilter.address" maxlength="100" outlined placeholder="eg. 123 Main Street"></v-text-field>

              </v-col>

              <v-col>

                <v-autocomplete label="Municipality" v-model="searchFilter.municipality" :items="lists.municipalities" hide-no-data maxlength="100" outlined></v-autocomplete>

              </v-col>

              <v-col>

                <v-autocomplete label="PID" v-model="searchFilter.PID" :items="lists.pids" maxlength="11" hide-no-data outlined placeholder="eg. 111-222-3333"></v-autocomplete>

              </v-col>

            </v-row>

            <v-row>

              <v-col>

                <v-text-field label="Other Location Details" v-model="searchFilter.otherLocationDetails" maxlength="250" outlined></v-text-field>

              </v-col>

              <v-col>

                <v-text-field label="MV Number" v-model="searchFilter.parcelReferenceNumber" maxlength="9" hide-no-data outlined placeholder="eg. P-0001000"></v-text-field>

              </v-col>

              <v-col>

                <v-autocomplete label="Parcel Registration Status" v-model="searchFilter.parcelRegistrationStatus" :items="['Unregistered', 'Registered', 'Future Registration', 'Registration Expired']" outlined maxlength="100" hide-no-data></v-autocomplete>

              </v-col>

            </v-row>

            <v-row>

              <v-col>

                <v-text-field label="Owner Name" v-model="searchFilter.owner" maxlength="100" outlined></v-text-field>

              </v-col>

              <v-col>

                <v-text-field label="Operator Name" v-model="searchFilter.operator" maxlength="100" outlined></v-text-field>

              </v-col>

              <v-col>

                <v-text-field label="Company Name" v-model="searchFilter.company" maxlength="100" outlined></v-text-field>

              </v-col>

            </v-row>

            <v-row>

              <v-col>

                <v-text-field label="Registration Number" v-model="searchFilter.registrationReferenceNumber" maxlength="9" outlined placeholder="eg. R-0001500"></v-text-field>

              </v-col>

              <v-col>

                <v-autocomplete label="Registrations Paid?" v-model="searchFilter.registrationsPaid" :items="['Yes', 'No']" maxlength="3" outlined hide-no-data></v-autocomplete>

              </v-col>

              <v-col>

                <v-autocomplete label="Payment Method" v-model="searchFilter.paymentMethod" :items="['Credit Card', 'Cheque', 'Cash']" maxlength="100" outlined hide-no-data></v-autocomplete>

              </v-col>

            </v-row>

            <v-row>

              <v-col>

                <v-menu v-model="startDateMenu" :close-on-content-click="false" transition="scale-transition" offset-y max-width="290px" min-width="auto">

                  <template v-slot:activator="{ on, attrs }">

                    <v-text-field v-model="searchFilter.registrationStartDate" label="Start Date" hint="MM/DD/YYYY" maxlength="10" :error-messages="startDateErrors" persistent-hint prepend-icon="mdi-calendar" v-bind="attrs" @blur="startDatePicker = parseDate(searchFilter.registrationStartDate)" v-on="on" outlined style="max-width: 175px"></v-text-field>

                  </template>

                  <v-date-picker v-model="startDatePicker" no-title @input="startDateMenu = false"></v-date-picker>

                </v-menu>

              </v-col>

              <v-col>

                <v-menu v-model="endDateMenu" :close-on-content-click="false" transition="scale-transition" offset-y max-width="290px" min-width="auto">

                  <template v-slot:activator="{ on, attrs }">

                    <v-text-field v-model="searchFilter.registrationEndDate" label="End Date" hint="MM/DD/YYYY" maxlength="10" :error-messages="endDateErrors" persistent-hint prepend-icon="mdi-calendar" v-bind="attrs" @blur="endDatePicker = parseDate(searchFilter.registrationEndDate)" v-on="on" outlined style="max-width: 175px"></v-text-field>

                  </template>

                  <v-date-picker v-model="endDatePicker" no-title @input="endDateMenu = false"></v-date-picker>

                </v-menu>

              </v-col>

              <v-col>

                <v-autocomplete label="Type of Burn" v-model="searchFilter.typeOfBurn" outlined  :items="['Agricultural', 'Commercial', 'Residential', 'Wildfire Risk Management']" maxlength="100" hide-no-data></v-autocomplete>

              </v-col>

            </v-row>

            <v-row>

              <v-col>

                <v-autocomplete label="Has Notes?" v-model="searchFilter.hasNotes" :items="['Yes', 'No']" outlined maxlength="3" hide-no-data></v-autocomplete>

              </v-col>

              <v-col>

                <v-text-field label="Notes" v-model="searchFilter.notes" maxlength="4000" outlined></v-text-field>

              </v-col>

              <v-col>

              </v-col>

            </v-row>

          </v-layout>

        </v-card-text>

        <v-card-actions>

          <v-spacer></v-spacer>

          <v-btn @click="searchDialog = false" color="primary">cancel</v-btn> <v-btn @click="search" color="primary">search</v-btn>

        </v-card-actions>

      </v-card>

    </v-dialog>

    <v-layout class="mb-2">

      <v-spacer></v-spacer>

      You are signed in as&nbsp;<strong>{{ $store.state.user.email }}</strong>&nbsp;<span v-if="$store.state.user.role != 'User'">({{ $store.state.user.role == 'Admin' ? 'Administrator' : $store.state.user.role }})</span>

    </v-layout>

    <v-card elevation="0" class="pa-2">

      <v-card-title class="text-h5 word-break"><strong>Dashboard</strong></v-card-title>

      <v-card-text class="text-body-1">

        <template>

          <div class="text-right">

            <v-btn color="primary" class="mb-4" @click="openSearchDialog"><v-icon left>mdi-magnify</v-icon>search</v-btn> <v-btn color="primary" class="mb-4" @click="reset">reset</v-btn>

          </div>

          <v-data-table :headers="headers" :items="parcels" class="elevation-1" @click:row="rowClick" sort-by="dateLastSubmitted" :sort-desc="true" :loading="loadingTable">

            <template v-slot:item.actions="{ item }">

              <v-icon small class="mr-2" @click.stop="editItem(item)">mdi-pencil</v-icon>

            </template>

          </v-data-table>

        </template>

      </v-card-text>

    </v-card>

  </v-container>

</template>

<script lang="ts">

import Vue from 'vue'

import axios from "axios";

export default Vue.extend({

  name: 'Success',

  async created() {

    this.loading = true;

    setTimeout(async () => {

      try {

        let obj = await axios.get('accounts/get-user-info');

        var tokens = obj.data.split('\t');

        var email = tokens[1];

        var role = tokens[2];

        this.$store.dispatch('updateEmail', email);

        this.$store.dispatch('updateRole', role);

        let addresses = { data: null as any };

        this.lists.addresses = addresses.data;

        let parcelReferenceNumbers = { data: null as any };

        this.lists.parcelReferenceNumbers = parcelReferenceNumbers.data;

        let registrationReferenceNumbers = { data: null as any };

        this.lists.registrationReferenceNumbers = registrationReferenceNumbers.data;

        let municipalities = await axios.get('api/Parcel/GetMunicipalities');

        this.lists.municipalities = municipalities.data;

        let pids = { data: null as any };

        this.lists.pids = pids.data;

      }
      catch (error:any)
      {
        // there was an exception

        if (error.response && error.response.status == 401) {

          // the exception is "Unauthorized", redirect to login screen

          if (this.$route.path != '/Login') this.$router.push('/Login');

        }
        else if (error.response && error.response.status == 404) {

          // the exception is "404 Not Found", redirect to 404 screen

          if (this.$route.path != '/NotFound') this.$router.push('/NotFound');

        }
        else {

          // all other exceptions

          this.clearSnackbars();

          this.snackbars.genericErrorText = 'There was an issue contacting the server.';

          this.snackbars.genericErrorSnackbar = true;

        }
      }

      this.loading = false;

      this.refreshParcels();

    }, 200)

  },

  watch: {

    startDatePicker (val) {

      this.searchFilter.registrationStartDate = this.formatDate(this.startDatePicker)

    },

    endDatePicker (val) {

      this.searchFilter.registrationEndDate = this.formatDate(this.endDatePicker)

    }

  },

  computed: {

    startDateErrors()
    {
      return [];
    },

    endDateErrors()
    {
      return [];
    }

  },

  data () {

    return {

      loadingTable: false,

      snackbars: {

        errorSnackbar: false,

        genericErrorSnackbar: false,

        genericErrorText: '',

        genericInfoSnackbar: false,

        genericInfoText: '',

      },

      searchFilter: {

        address: '',

        municipality: '',

        PID: '',

        otherLocationDetails: '',

        parcelReferenceNumber: '',

        parcelRegistrationStatus: '',

        owner: '',

        operator: '',

        company: '',

        registrationReferenceNumber: '',

        registrationsPaid: '',

        paymentMethod: '',

        registrationStartDate: '',

        registrationEndDate: '',

        typeOfBurn: '',

        hasNotes: '',

        notes: ''

      },

      lists: {

        addresses: [],

        municipalities: [],

        parcelReferenceNumbers: [],

        registrationReferenceNumbers: [],

        pids: []

      },

      loading: false,

      searchDialog: false,

      headers: [

        { text: 'Address', value: 'address', class: 'primary white--text'},

        { text: 'Municipality', value: 'municipality', class: 'primary white--text' },

        { text: 'Status', value: 'status', class: 'primary white--text' },

        { text: 'Start Date', value: 'startDate', class: 'primary white--text' },

        { text: 'Type of Burn', value: 'typeOfBurn', class: 'primary white--text' },

        { text: 'Date Notified', value: 'dateNotified', class: 'primary white--text' },

        { text: 'Actions', value: 'actions', class: 'primary white--text', sortable: false }

      ],

      parcels: [],

      startDateMenu: false,

      startDatePicker: '',

      endDateMenu: false,

      endDatePicker: ''

    }

  },

  methods: {

    formatDate (date:any):any {

      if (!date) return null

      const [year, month, day] = date.split('-')

      return `${month}/${day}/${year}`

    },

    parseDate (date:any):any {

      if (!date) return null

      const [month, day, year] = date.split('/')

      return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`

    },

    async refreshParcels() {

      this.loadingTable = true;

      let parcels = { data: null as any };

      this.loadingTable = false;

      this.parcels = parcels.data;

    },

    clearSnackbars() {

      this.snackbars.genericInfoSnackbar = false;

      this.snackbars.genericErrorSnackbar = false;

    },

    rowClick(obj: any)
    {
      this.clearSnackbars();

      if (this.$route.path != '/Form') this.$router.push('/Form?id=' + obj.id);
    },

    openSearchDialog()
    {
      this.clearSnackbars();

      this.searchFilter.address = '';

      this.searchFilter.municipality = '',

          this.searchFilter.PID = '';

      this.searchFilter.otherLocationDetails = '';

      this.searchFilter.parcelReferenceNumber = '';

      this.searchFilter.parcelRegistrationStatus = '';

      this.searchFilter.owner = '';

      this.searchFilter.operator = '';

      this.searchFilter.company = '';

      this.searchFilter.registrationReferenceNumber = '';

      this.searchFilter.registrationsPaid = '';

      this.searchFilter.paymentMethod = '';

      this.searchFilter.registrationStartDate = '';

      this.searchFilter.registrationEndDate = '';

      this.searchFilter.typeOfBurn = '';

      this.searchFilter.hasNotes = '';

      this.searchFilter.notes = '';

      this.searchDialog = true;
    },

    async search() {

      this.searchDialog = false;

      this.loading = true;

      setTimeout(async () => {

        let obj = { data: null as any };

        this.parcels = obj.data;

        this.loading = false;

      }, 200);

    },

    async reset() {

      this.searchFilter.address = '';

      this.searchFilter.municipality = '',

          this.searchFilter.PID = '';

      this.searchFilter.otherLocationDetails = '';

      this.searchFilter.parcelReferenceNumber = '';

      this.searchFilter.parcelRegistrationStatus = '';

      this.searchFilter.owner = '';

      this.searchFilter.operator = '';

      this.searchFilter.company = '';

      this.searchFilter.registrationReferenceNumber = '';

      this.searchFilter.registrationsPaid = '';

      this.searchFilter.paymentMethod = '';

      this.searchFilter.registrationStartDate = '';

      this.searchFilter.registrationEndDate = '';

      this.searchFilter.typeOfBurn = '';

      this.searchFilter.hasNotes = '';

      this.searchFilter.notes = '';

      this.loading = true;

      setTimeout(async () => {

        this.refreshParcels();

        this.loading = false;

      }, 100);

    },

    async editItem(row: any) {

      this.clearSnackbars();

      if (this.$route.path != '/Form') this.$router.push('/Form?id=' + row.id);

    }

  }

})

</script>

<style>

.word-break {

  word-break: break-word;

}

th > .v-icon {

  color: white !important;

}

th, td {

  font-size: 18px !important;

}

</style>
